import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import InputDialog from "./InputDialog";
import KeyPad from "./KeyPad";
import OutlineButton from "./forms/buttons/OutlineButton";
import Button from "./forms/buttons/Button";

/**
 * 選択肢ダイアログコンポーネント
 * @param {string} name 項目名
 * @param {string} value 値
 * @param {Array} options 選択肢
 * @param {Array} otherOptions その他の選択肢
 * @param {Function} onChange 値確定時の処理
 * @param {string} title ダイアログタイトル
 * @param {boolean} open ダイアログ表示/非表示フラグ
 * @param {Function} onClose ダイアログを閉じる際の処理
 * @param {boolean} showKeypad キーパッドを表示するかどうか
 * @class SelectDialog
 */
export default function SelectDialog({
  name,
  value,
  options = [],
  otherOptions = [],
  onChange,
  title,
  subtitle,
  open,
  onClose,
  showKeypad = false,
}) {
  const [localValue, setLocalValue] = useState("");
  const regexp = new RegExp(`^${localValue}`, "gi");
  const filterOptions = options.filter((o) =>
    showKeypad ? o.label.match(regexp) !== null : true,
  );
  const [isShowKeypad, setShowKeypad] = useState(showKeypad);
  /**
   * 選択肢の変更を反映し、ダイアログを閉じる
   * @param {string} value 値
   */
  const onSubmit = (value) => {
    onChange(name, value);
    onDialogClose();
  };
  const onDialogClose = () => {
    setShowKeypad(showKeypad);
    onClose();
  };
  useEffect(() => {
    setShowKeypad(showKeypad);
  }, [showKeypad]);
  return (
    <InputDialog
      open={open}
      onClose={onDialogClose}
      title={title}
      subtitle={subtitle}
      fullScreen={isMobile}
      type={showKeypad ? "key-pad" : "select"}
    >
      <div className={`select-dialog-contents ${showKeypad ? "key-pad" : ""}`}>
        {showKeypad && (
          <div className="search-box-row">
            <input
              className="search-input"
              id="modelSearchInput"
              type="text"
              value={localValue}
              placeholder="機種名を入力"
              aria-label="機種検索"
            />
            <OutlineButton title="クリア" onClick={() => setLocalValue("")} />
            <Button
              title="検索結果を見る"
              onClick={() => setShowKeypad(false)}
            />
          </div>
        )}
        {isShowKeypad && (
          <KeyPad defaultValue={`${localValue}`} onChange={setLocalValue} />
        )}

        <div
          className={`${showKeypad ? "button-list" : "buttons"} ${isShowKeypad ? "" : "full"}`}
        >
          {filterOptions.map((option) => (
            <button
              key={`option${option.value}`}
              onClick={() => onSubmit(option.value)}
              className={value === option.value ? "selected" : ""}
            >
              {option.label}
              {option.desc && <small>{option.desc}</small>}
            </button>
          ))}
          {showKeypad && filterOptions.length === 0 && (
            <div className="empty-result">該当する機種がありません</div>
          )}
        </div>
      </div>
    </InputDialog>
  );
}
